<template>
    <div>
        <h2>{{ $t('eventRegistration.payment.coupon') }} {{ redeemedCoupon.couponId }}</h2>
        <h4 class="mb-0">{{ $t('eventRegistration.payment.redeemedAmount') }}</h4>
        <div class="h1">{{ redeemedCoupon.redeemedAmount }} {{ currencySymbol }}</div>
    </div>
</template>

<script>
import registrationPriceMixin from "@/mixins/registration/registrationPriceMixin";

export default {
    name: "RedeemedCoupon",
    mixins: [registrationPriceMixin],
    props: {
        redeemedCoupon: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
